export default __webpack_public_path__ + "2c204ebd4ff2158bce9f0c5ab1207103.png";